module.exports = __webpack_public_path__ + "img/mcluster_product_2.ed6d22f0.jpg";